<template>
  <main class="semester subm" :key="semester.uid">
    <sub-menu parent="teaching" title="Semesters" :items="teaching.semesters" />
    <section class="news">
      <div class="col fw">
        <print class="abs" />
        <course
          v-for="course in semester.courses"
          :key="course.uid"
          :course="course"
        />
        <div class="filler">
          <div class="p br"></div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
import SubMenu from "@/components/SubMenu.vue";
import Print from "@/components/Print.vue";
import Course from "@/components/Course.vue";
import { mapState } from "vuex";
export default {
  name: "semester",
  metaInfo() {
    return {
      title: "– " + this.semester.title
    };
  },
  components: {
    SubMenu,
    Course,
    Print
  },
  computed: {
    ...mapState(["teaching"]),
    semester() {
      return this.$store.getters.getSemesterByUID(this.$route.params.id);
    }
  }
};
</script>
